import { catchError, getError, http } from "services/http"
import i18next from "i18next"
import { Entity, ErrorFn, ErrorResponse, UpdateEntityData, UpdateEntityOperators } from "models"

const getPartners = async (status: string): Promise<{ res: Entity[] } & ErrorFn> => {
    const getPartnersErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                switch (error?.message) {
                    case "Access token is required.":
                        return { code: error?.code, message: i18next.t("sell_error_AccessTokenRequired", { ns: "api" }) }
                    case "Operation is not allowed: role.":
                    case "Operation is not allowed: operateur.":
                        return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }) }
                    default:
                        return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
                }
            case "EntityNotFoundException":
                return { code: error?.code, message: i18next.t("edit_errorEntityNotFoundException", { ns: "api" }) }
            default:
                return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
        }
    }
    const param = `?status=${status}`
    const res = await http
        .get<Entity[]>(`obikeapi/backend/entities${param}`, {})
		.then((res) => res.data)
        .catch(e => catchError(e))
    return {
        res: res as Entity[],
        getError: getError(res, getPartnersErrors)
    }
}

const getPartner = async (partnerId: string): Promise<{ res: Entity } & ErrorFn> => {
    const getPartnerErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                switch (error?.message) {
                    case "Access token is required.":
                        return { code: error?.code, message: i18next.t("sell_error_AccessTokenRequired", { ns: "api" }) }
                    case "Operation is not allowed.":
                    case "Operation is not allowed: role.":
                    case "Operation is not allowed: operateur.":
                    case "Operation is not allowed: permission.":
                        return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }) }
                    default:
                        return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
                }
            case "EntityNotFoundException":
                return { code: error?.code, message: i18next.t("edit_errorEntityNotFoundException", { ns: "api" }) }
            case "MailNotAvailableException":
                return { code: error?.code, message: i18next.t("edit_errorMailNotAvailableException", { ns: "form" }) }
            case "TooManyRequestsException":
                return { code: error?.code, message: i18next.t("edit_error_TooManyRequestsException", { ns: "api" }) }
            case "DuplicatesValueException":
                return { code: error?.code, message: i18next.t("edit_error_DuplicatesValueException", { ns: "form" }) }
            default:
                return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
        }
    }
    const res = await http
        .get<Entity>(`obikeapi/entity?entity_id=${partnerId}`, {})
		.then((res) => res.data)
        .catch(e => catchError(e))
    return {
        res: res as Entity,
        getError: getError(res, getPartnerErrors)
    }
}

const getOldPartner = async (storeId: string): Promise<{ res: Entity } & ErrorFn> => {
    const getOldPartnerErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                switch (error?.message) {
                    case "Access token is required.":
                        return { code: error?.code, message: i18next.t("sell_error_AccessTokenRequired", { ns: "api" }) }
                    case "Operation is not allowed.":
                    case "Operation is not allowed: role.":
                    case "Operation is not allowed: operateur.":
                    case "Operation is not allowed: permission.":
                        return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }) }
                    default:
                        return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
                }
            case "EntityNotFoundException":
                return { code: error?.code, message: i18next.t("edit_errorEntityNotFoundException", { ns: "api" }) }
            case "MailNotAvailableException":
                return { code: error?.code, message: i18next.t("edit_errorMailNotAvailableException", { ns: "form" }) }
            case "TooManyRequestsException":
                return { code: error?.code, message: i18next.t("edit_error_TooManyRequestsException", { ns: "api" }) }
            case "DuplicatesValueException":
                return { code: error?.code, message: i18next.t("edit_error_DuplicatesValueException", { ns: "form" }) }
            default:
                return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
        }
    }
    const res = await http
        .get<Entity>(`obikeapi/entity?old_store_id=${storeId}`, {})
		.then((res) => res.data)
        .catch(e => catchError(e))
    // console.log("getOldPartner res: ", res)
    return {
        res: res as Entity,
        getError: getError(res, getOldPartnerErrors)
    }
}

const createPartner = async (partner): Promise<{ res: any } & ErrorFn> => {
    const createPartnerErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                switch (error?.message) {
                    case "Access token is required.":
                        return { code: error?.code, message: i18next.t("sell_error_AccessTokenRequired", { ns: "api" }) }
                    case "Operation is not allowed: role.":
                    case "Operation is not allowed: operateur.":
                        return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }) }
                    default:
                        return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
                }
            case "TooManyRequestsException":
                return { code: error?.code, message: i18next.t("edit_error_TooManyRequestsException", { ns: "api" }) }
            case "WalletNotFoundException":
                return { code: error?.code, message: i18next.t("edit_error_WalletNotFoundException", { ns: "form" }) }
            case "EntityStatusException":
                return { code: error?.code, message: i18next.t("edit_error_EntityStatusException", { ns: "form" }) }
            case "MailNotAvailableException":
                return { code: error?.code, message: i18next.t("edit_errorMailNotAvailableException", { ns: "form" }) }
            case "DuplicatesValueException":
                switch (error?.message) {
                    case "Duplicates value : operator_store_id.":
                        return { code: error?.code, message: i18next.t("edit_error_DuplicatesValueExceptionStoreid", { ns: "form" }) }
                    case "Duplicates value : wallet_id.":
                        return { code: error?.code, message: i18next.t("edit_error_DuplicatesValueExceptionWalletid", { ns: "form" }) }
                    case "Duplicates value : siret.":
                        return { code: error?.code, message: i18next.t("edit_error_DuplicatesValueException", { ns: "form" }) }
                    default:
                        return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
                }
            default:
                return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
        }

    }
    const res = await http
        .post("obikeapi/backend/entity", partner, {})
		.then((res) => res.data)
        .catch(e => catchError(e))
    return {
        res,
        getError: getError(res, createPartnerErrors)
    }
}

const editPartner = async (partner) => {
    const editPartnerErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                switch (error?.message) {
                    case "Access token is required.":
                        return { code: error?.code, message: i18next.t("sell_error_AccessTokenRequired", { ns: "api" }) }
                    case "Operation is not allowed: role.":
                    case "Operation is not allowed: operateur.":
                    case "Operation is not allowed: entity suspended.":
                        return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }) }
                    default:
                        return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
                }
            case "TooManyRequestsException":
                return { code: error?.code, message: i18next.t("edit_error_TooManyRequestsException", { ns: "api" }) }
            case "EntityStatusException":
                return { code: error?.code, message: i18next.t("edit_error_EntityStatusException", { ns: "form" }) }
            case "MailNotAvailableException":
                return { code: error?.code, message: i18next.t("edit_errorMailNotAvailableException", { ns: "form" }) }
            case "DuplicatesValueException":
                return { code: error?.code, message: i18next.t("edit_error_DuplicatesValueException", { ns: "form" }) }
            default:
                return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
        }

    }
    //const res = await http.post(`obikeapi/backend/entity`, partner, {}).catch(e => http.catchError(e))
    const res = true
    // console.log("editPartner res: ", res)
    return {
        res,
        getError: getError(res, editPartnerErrors)
    }
}

type UpdatePartnerResponse = {
    entity_id: string
}

const updatePartnerAccount = async (partner: UpdateEntityData): Promise<{ res: UpdatePartnerResponse } & ErrorFn> => {
    const updatePartnerAccountErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                switch (error?.message) {
                    case "Access token is required.":
                        return { code: error?.code, message: i18next.t("sell_error_AccessTokenRequired", { ns: "api" }) }
                    case "Operation is not allowed: role.":
                    case "Operation is not allowed: operateur.":
                        return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }) }
                    case "Operation is not allowed: entity suspended.":
                        return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedExceptionSuspended", { ns: "form" }) }
                    default:
                        return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
                }
            case "WalletNotFoundException":
                return { code: error?.code, message: i18next.t("edit_error_WalletNotFoundException", { ns: "form" }) }
            case "TooManyRequestsException":
                return { code: error?.code, message: i18next.t("edit_error_TooManyRequestsException", { ns: "api" }) }
            case "EntityStatusException":
                return { code: error?.code, message: i18next.t("edit_error_EntityStatusException", { ns: "form" }) }
            case "MailNotAvailableException":
                return { code: error?.code, message: i18next.t("edit_errorMailNotAvailableException", { ns: "form" }) }
            case "DuplicatesValueException":
                switch (error?.message) {
                    case "Duplicates value : operator_store_id.":
                        return { code: error?.code, message: i18next.t("edit_error_DuplicatesValueExceptionStoreid", { ns: "form" }) }
                    case "Duplicates value : wallet_id.":
                        return { code: error?.code, message: i18next.t("edit_error_DuplicatesValueExceptionWalletid", { ns: "form" }) }
                    case "Duplicates value : siret.":
                        return { code: error?.code, message: i18next.t("edit_error_DuplicatesValueException", { ns: "form" }) }
                    default:
                        return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
                }
            case "EntityVersionMismatchException":
                return { code: error?.code, message: i18next.t("account_error_EntityVersionMismatchException", { ns: "form" }) }
            case "SalesforceAccountNotFoundException":
                return { code: error?.code, message: i18next.t("salesforce_error_SalesforceAccountNotFoundException", { ns: "form" }) }
            case "updateOrCreateAccountContactException":
                switch (error?.message) {
                    case "NUMBER_OUTSIDE_VALID_RANGE":
                        return { code: error?.code, message: i18next.t("salesforce_error_numberOutsideValidRange", { ns: "form" }) }
                    case "STRING_TOO_LONG":
                        return { code: error?.code, message: i18next.t("salesforce_error_stringTooLong", { ns: "form" }) }
                    default:
                        return { code: error?.code, message: i18next.t("salesforce_error_updateOrCreateAccountContactException", { ns: "form" }) }
                }
            default:
                return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
        }

    }
    const res = await http
        .put<UpdateEntityData>("obikeapi/backend/entity", partner, {})
		.then((res) => res.data)
        .catch(e => catchError(e))

    return {
        res: res as UpdatePartnerResponse,
        getError: getError(res, updatePartnerAccountErrors)
    }
}


const updatePartnerOperator = async (operators: UpdateEntityOperators): Promise<{ res: UpdatePartnerResponse } & ErrorFn> => {
    const updatePartnerAccountErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                switch (error?.message) {
                    case "Access token is required.":
                        return { code: error?.code, message: i18next.t("sell_error_AccessTokenRequired", { ns: "api" }) }
                    case "Operation is not allowed: role.":
                    case "Operation is not allowed: operateur.":
                        return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }) }
                    case "Operation is not allowed: entity suspended.":
                        return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedExceptionSuspended", { ns: "form" }) }
                    default:
                        return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
                }
            case "TooManyRequestsException":
                return { code: error?.code, message: i18next.t("edit_error_TooManyRequestsException", { ns: "api" }) }
            case "EntityStatusException":
                return { code: error?.code, message: i18next.t("edit_error_EntityStatusException", { ns: "form" }) }
            case "MailNotAvailableException":
                return { code: error?.code, message: i18next.t("edit_errorMailNotAvailableException", { ns: "form" }) }
            case "DuplicatesValueException":
                switch (error?.message) {
                    case "Duplicates value : operator_store_id.":
                        return { code: error?.code, message: i18next.t("edit_error_DuplicatesValueExceptionStoreid", { ns: "form" }) }
                    default:
                        return { code: error?.code, message: i18next.t("edit_error_DuplicatesValueException", { ns: "form" }) }
                }
            case "EntityVersionMismatchException":
                return { code: error?.code, message: i18next.t("account_error_EntityVersionMismatchException", { ns: "form" }) }
            default:
                return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
        }

    }
    const res = await http
        .put<UpdateEntityOperators>("obikeapi/backend/entity/operators", operators, {})
		.then((res) => res.data)
        .catch(e => catchError(e))

    return {
        res: res as UpdatePartnerResponse,
        getError: getError(res, updatePartnerAccountErrors)
    }
}


export const updateEntity = async (entity): Promise<{ res: any } & ErrorFn> => {
    // console.log("entity", entity)
    const updatePartnerAccountErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }) }
            case "TooManyRequestsException":
                return { code: error?.code, message: i18next.t("edit_error_TooManyRequestsException", { ns: "api" }) }
            case "EntityVersionMismatchException":
                return { code: error?.code, message: i18next.t("account_error_EntityVersionMismatchException", { ns: "form" }) }
            default:
                return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
        }
    }
    const res = await http.put("obikeapi/entity", entity, {}).catch(e => catchError(e))
    return {
        res: res as any,
        getError: getError(res as unknown as ErrorResponse, updatePartnerAccountErrors)
    }
}


const editEntityOperators = async (updatedOperators) => {
    const editEntityOperatorsErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "InvalidArgument":
                switch (error?.message) {
                    case "Bad data_operators BC: already have money order.":
                        return { code: error?.code, message: i18next.t("already_money_order", { ns: "form" }) }
                    case "Bad data_operators: RUM format is not valid.":
                        return { code: error?.code, message: i18next.t("invalid_rum", { ns: "form" }) }
                    case "Bad entity_data address.":
                        return { code: error?.code, message: i18next.t("bad_entity_data_address", { ns: "form" }) }
                    default:
                        break
                }
                break

            case "NotAuthorizedException":
                switch (error?.message) {
                    case "Credentials are required.":
                        return { code: error?.code, message: i18next.t("credentials_required", { ns: "form" }) }

                    case "Operation is not allowed":
                    case "Operation is not allowed: role.":
                    case "Operation is not allowed: entity suspended.":
                        return { code: error?.code, message: i18next.t("operation_not_allowed", { ns: "form" }) }

                    case "Entity is not found.":
                        return { code: error?.code, message: i18next.t("entity_not_found", { ns: "form" }) }
                    default:
                        break
                }
                break

            default:
                return { code: error?.code, message: i18next.t("global_error", { ns: "form" }) }
        }
    }
    const res = await http.put("obikeapi/entity/operators", updatedOperators).catch(e => catchError(e))

    return {
        res,
        getError: getError(res, editEntityOperatorsErrors)
    }
}

export {
    getPartners,
    getPartner,
    getOldPartner,
    createPartner,
    editPartner,
    updatePartnerAccount,
    updatePartnerOperator,
    editEntityOperators
}
